import React from 'react';
import "../App.css";

// ─────────────────────────────────────────────────────────────────────
// <StatusFilter> — compact status dropdown that replaces the long,
// wrapping row of status "chips" on the Tasks and Invoices pages.
//
// Props:
//   value    — currently selected status id
//   onChange — (id) => void
//   options  — [{ id, label, count }]  (count optional)
//   label    — small caption shown above/left of the select (default "Status")
// ─────────────────────────────────────────────────────────────────────
export function StatusFilter({ value, onChange, options = [], label = "Status" }) {
  const total = options.reduce((s, o) => s + (typeof o.count === "number" ? o.count : 0), 0);
  return (
    <div className="status-filter">
      {label && <span className="status-filter-lbl">{label}</span>}
      <select
        className="f-select status-filter-select"
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-label={label || "Status filter"}
      >
        {options.map(o => (
          <option key={o.id} value={o.id}>
            {o.label}{typeof o.count === "number" ? ` (${o.count})` : ""}
          </option>
        ))}
      </select>
    </div>
  );
}

export default StatusFilter;
